import type { ITimeline } from '../types';

export const getTextWidth = (text: string, maxWidth: number) => {
  let newText = '';
  let resultWidth = 0;
  let overflow = false;
  const arr = text.split('');
  const span = document.createElement('span');
  span.style.visibility = 'hidden';
  span.style.padding = '0';
  span.style.whiteSpace = 'nowrap';
  span.style.overflowX = 'auto';
  span.style.fontSize = '14px';
  span.style.fontWeight = '400';
  document.body.appendChild(span);
  for (let i = 0, l = arr.length;i < l;i++) {
    const item = arr[i];
    newText += item;
    span.innerHTML = newText;
    const nowWidth = span.offsetWidth;
    if (nowWidth > maxWidth) {
      overflow = true;
      resultWidth = maxWidth;
      break;
    }
    if (i === l - 1) {
      resultWidth = nowWidth;
    }
  }
  document.body.removeChild(span);

  return {
    width: resultWidth,
    isOverflow: overflow,
  };
};

/**
 * 计算current milestone、next milestone的索引（忽略是否带子milestone）
 * 折叠时，即不带子milestone时，current为页面传入的，next为current + 1
 * 展开时，即带子milestone时
 *  1、根据不带子milestone的milestones集合，页面传入的current 计算出 next（current + 1），从而计算出 current节点，next节点
 *  2、根据current节点、next节点，带子milestone的milestones集合，计算出current、next的索引（通过id查找索引，这个索引是针对带子milestone的milestones集合）
 * @param timelines milestone的milestones集合
 * @param current current milestone的索引（不带子milestone的milestones集合）
 * @returns.current current milestone的索引（无论是否带子milestone）
 * @returns.next next milestone的索引（无论是否带子milestone）
 */
export const calcCurrentNextIndex = (timelines: ITimeline[], current: number): { current: number; next: number; } => {
  // 异常数据 直接返回current、next 索引都是-1
  if (!Array.isArray(timelines) || !timelines.length) return { current: -1, next: -1 };
  return { current, next: current + 1 };
};
